<template>
  <div class="update-site-inspection-dialog">
    <v-card>
      <v-card-title>{{ item.name }} 점검기록 수정</v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="item.title"
                  :rules="titleValidation"
                  label="제목"
                  type="text"
                  required/>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-textarea
                  v-model="item.contents"
                  label="내용"
                  :rules="contentsValidation"
                  required
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn text color="error" @click="updateInspection(item)">확인</v-btn>
        <v-btn text @click="dialog.updateInspectionDialog = false">취소</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'updateSiteInspectionDialog',
    props: {
      dialog: {
        type: Object,
        required: true
      },
      item: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        titleValidation: [
          value => !!value || '필수 값입니다',
          value => value.length <= 50 || '최대 길이는 50을 넘을 수 없습니다'
        ],
        contentsValidation: [
          value => !!value || '필수 값입니다',
          value => value.length <= 32766 || '최대 길이는 32766을 넘을 수 없습니다'
        ],
      }
    },
    methods: {
      updateInspection(inspection) {
        const retryFuncBackup = this.updateInspection.bind(this, inspection);

        if (!this.$refs.form.validate()) {
          return;
        }

        const baseUri = process.env.VUE_APP_API_SERVER;
        const targetUri = `${baseUri}/siteInspections/${inspection.id}`;

        this.$bus.$emit('loading', true);

        const siengLoginInfoCookie = $cookies.get('siengLoginInfo');
        const config = {
          headers: {
            Authorization: `Bearer ${siengLoginInfoCookie.accessToken}`
          }
        };

        axios.put(targetUri, inspection, config)
          .then(result => {
            this.popupAlert('점검기록 업데이트 성공', 'green');
          })
          .catch(error => {
            if (!error.hasOwnProperty('response')) {
              console.error(error);
              this.popupAlert(error.toString(), 'red');
              return;
            }

            if (error.response.status === 401 && "TOKEN_REFRESH_NEEDED" === error.response.data.detailedErrorCode) {
              this.$bus.$emit('refreshTokenAndRetryIfPossible', error, retryFuncBackup);
              return;
            }

            console.error(error.response);
            this.popupAlert(error.toString(), 'red');
          })
          .finally(() => {
            this.$bus.$emit('loading', false);
            this.dialog.updateInspectionDialog = false;
            this.refreshSiteInspections();
          });
      },
      printDebugLog(target) {
        console.dir(target);
      },
      popupAlert(message, color) {
        this.$bus.$emit('popupAlert', {message: message, color: color});
      },
      refreshSiteInspections() {
        this.$bus.$emit('refreshSiteInspections');
      }
    },
    mounted() {
    }
  }
</script>